<script>
import fecha from 'fecha'

export default {
  methods: {
    crmDateFormat(date, format = 'DD-MM-YYYY HH:mm') {
      if (date) {
        return fecha.format(fecha.parse(date, 'YYYY-MM-DDTHH:mm:ss'), format)
      }
    },
    simpleDateFormat(date, format = 'YYYY年MM月DD日') {
      if (date && this.$moment(date).isValid) {
        return this.$moment(date).format(format)
      } else {
        return null
      }
    }
  }
}
</script>
